import { render } from "./MostaTreeSelect.vue?vue&type=template&id=f1270c4c&scoped=true&ts=true"
import script from "./MostaTreeSelect.vue?vue&type=script&lang=ts"
export * from "./MostaTreeSelect.vue?vue&type=script&lang=ts"

import "./MostaTreeSelect.vue?vue&type=style&index=0&id=f1270c4c&lang=scss&scoped=true"
import "./MostaTreeSelect.vue?vue&type=style&index=1&id=f1270c4c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1270c4c"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
